import {CommandBuilder} from "./command/command-builder";

export function __tcfapi(command:string, version:number, callback:Function, parameter:number|number[]) {

    CommandBuilder.build(command)?.execute(version, callback, parameter);

}

export function __tcfapiprivate(command:string, option?:string, callback?:Function) {

    CommandBuilder.buildPrivate(command)?.execute(option, callback);

}
